import { Tooltip, IconButton, PopperPlacementType } from '@mui/material'
import { HelpOutline } from '@mui/icons-material'
import React from 'react'

interface HelpIconProps {
  helperText: string
  placement: PopperPlacementType
}

export const HelpIcon: React.FC<HelpIconProps> = ({
  helperText,
  placement
}) => {
  return (
    <Tooltip title={helperText} placement={placement}>
      <IconButton>
        <HelpOutline />
      </IconButton>
    </Tooltip>
  )
}
